/* global $ */


$(document).ready(() => {
	function wrapCheckBox(form) {
	    const $checks = $(form).find('input[type=checkbox]');
	    const check =
	      '<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="428.772,55.96 196.737,288.922 83.228,174.957 0.013,258.516 196.69,456.039 511.987,139.488 "></polygon></svg>';
	    if ($checks) {
	      $checks.each(function() {
	        const $this = $(this);
	        if (!$this.hasClass('customized')) {
	            $this.parent().addClass('customized custom-check');
	            $this.addClass('customized');
	            $($this).after(`<span class="checkmark">${check}</span>`);
	        }
	      });
	    }
	}

	function clearSearchVal(field, button) {
		// Clear the search input value and trigger input/change event
		$(button).on('click', function(e) {
			e.preventDefault();
			$(field).val('').trigger('input').trigger('change');
		});
	}

	// Wrap checkboxes in Search and filter forms
	$('form.searchandfilter').each(function(i) {
		wrapCheckBox(this, i);
	});

	// Add a clear button to justice under siege search form
	const $searchFieldWrapper = $('.justice_under_siege__sftp-search-container .sf-field-search label');
	const $searchField = $searchFieldWrapper.find('.sf-input-text');

	// Remove any existing clear button to avoid duplicates
	$searchFieldWrapper.find('.sf-field-search__clear').remove();

	// Add the clear button if it doesn't exist
	$searchFieldWrapper.append('<a href="#" class="sf-field-search__clear" style="display: none;"><svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" xml:space="preserve"><title>Close Button</title><path fill="#FFFFFF" d="M14 1.11L12.9 0 7 5.9 1.1 0 0 1.11 5.88 7 0 12.89 1.1 14 7 8.1l5.9 5.9 1.1-1.11L8.12 7z"/></svg></a>');
	const $clearBtn = $searchFieldWrapper.find('.sf-field-search__clear');

	// Show or hide the clear button based on input value
	function toggleClearButton() {
		if ($searchField.val() !== '') {
			$searchFieldWrapper.addClass('has-value');
			$clearBtn.show();
		} else {
			$searchFieldWrapper.removeClass('has-value');
			$clearBtn.hide();
		}
	}

	// Initial check
	toggleClearButton();

	// Listen for input changes
	$searchField.on('input', toggleClearButton);

	clearSearchVal($searchField, $clearBtn);
	
});
